import React, { useEffect, useState } from "react";
import { CustomButton, icon, SearchInput } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import { debounce } from "../../../../../common/utils";
import styles from "./FilterHeader.module.css";

const debounceFunc = debounce((func) => func(), 500);

export default function FilterHeader({ actionTitle, onChangeFilters, onOpen }) {
	const [name, setName] = useState("");
	useEffect(() => {
		debounceFunc(() => onChangeFilters({ name }));
	}, [name, onChangeFilters]);
	const handleChangeSearchValue = (e) => {
		const { value } = e.target;
		setName(value);
	};
	const handleClearSearchValue = () => {
		setName("");
	};
	return (
		<div className={`${styles.header} ${!onOpen && styles["header--fullwidth"]}`}>
			<SearchInput
				className={styles[(onOpen && "searchContainer__textfield") || "searchContainer__textfield--fullwidth"]}
				label={translate("common:btn.search")}
				value={name}
				onChange={handleChangeSearchValue}
				onClearSearch={handleClearSearchValue}
			/>
			{onOpen && typeof onOpen === "function" && (
				<CustomButton color="primary" startIcon={icon.faPlus} variant="contained" onClick={onOpen}>
					{translate(actionTitle)}
				</CustomButton>
			)}
		</div>
	);
}
